import { render, staticRenderFns } from "./RegisAddSubject.vue?vue&type=template&id=40730830&scoped=true"
import script from "./RegisAddSubject.vue?vue&type=script&lang=js"
export * from "./RegisAddSubject.vue?vue&type=script&lang=js"
import style0 from "./RegisAddSubject.vue?vue&type=style&index=0&id=40730830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40730830",
  null
  
)

export default component.exports